import { FormGroup, ValidationErrors } from "@angular/forms";

export const matchValidator = (controlName: string, matchingControlName: string) => {
  return (formGroup: FormGroup): ValidationErrors | null => {
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (!control || !matchingControl) {
      return null; // one of them is missing
    }

    return control.value === matchingControl.value ? null : { mismatch: true };
  };
}